module.exports = __webpack_public_path__ + "static/media/consultorio-01.69dcb74b.JPG";